import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconKey3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconKey3"><Circle cx="16.5" cy="7.5" r="4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M13 11L3.5 20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M8.5323 16.2441L9.46647 17.1783C10.1254 17.8373 10.1254 18.9057 9.46646 19.5646C8.80751 20.2236 7.73912 20.2236 7.08016 19.5646L6.09375 18.5782" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconKey3;
